<template>
  <div v-if="roles.length > 0">
    <b-card title="Ingresa los datos">

      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label="Nombres">
                <validation-provider
                  #default="{ errors }"
                  name="Nombres"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.first_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Nombres"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Apellidos">
                <validation-provider
                  #default="{ errors }"
                  name="Apellidos"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.last_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Apellidos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Tipo de Documento">
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de Documento"
                  rules="required"
                >
                  <b-form-select
                    v-model="form.document_type"
                    :state="errors.length > 0 ? false : null"
                    :options="documentTypes"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Número de Documento">
                <validation-provider
                  #default="{ errors }"
                  name="Número de Documento"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.document_number"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Número de Documento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Rol">
                <validation-provider
                    #default="{ errors }"
                    name="Rol"
                    rules="required"
                >
                  <b-form-select
                      v-model="form.role_id"
                      :state="errors.length > 0 ? false : null"
                      :options="roles"
                      :disabled="[5].includes(userData.role_id)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col v-if="form.role_id == 5" md="6">
              <b-form-group label="ReTHUS">
                <validation-provider
                    #default="{ errors }"
                    name="ReTHUS"
                    rules="required"
                >
                  <b-form-input
                      v-model="form.rethus"
                      :state="errors.length > 0 ? false : null"
                      placeholder="ReTHUS"
                  />
                  <b-form-text class="small">Registro Único Nacional de Talento Humano en Salud </b-form-text>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Fecha de Nacimiento">
                <b-form-input
                  v-model="form.birth_date"
                  type="date"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Correo Electrónico">
                <validation-provider
                  #default="{ errors }"
                  name="Correo Electrónico"
                  rules="required|email"
                >
                  <b-form-input
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Correo Electrónico"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Teléfono">
                <validation-provider
                  #default="{ errors }"
                  name="Teléfono"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.phone"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Teléfono"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                :disabled="loading"
                :variant="loading ? 'secondary' : 'success'"
                type="submit"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-2"
                />
                {{ loading ? 'Creando...' : 'Crear usuario' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>

      </validation-observer>

    </b-card>
  </div>

  <loading-skeleton v-else />
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormInput, BRow, BCol, BFormGroup, BCardText, BButton, BCard, BForm, BFormSelect, BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'
import api from '@/plugin/axios'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'

export default {
  components: {
    LoadingSkeleton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BForm,
    BFormSelect,
    BSpinner,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        document_type: '',
        document_number: '',
        rethus: '',
        birth_date: '',
        email: '',
        phone: '',
        role_id: '',
      },
      documentTypes: [
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'CE', text: 'Cédula de Extranjería' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'NIT', text: 'NIT' },
      ],
      roles: [],
      required,
      loading: false,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async created() {
    const [rolesRes] = await Promise.all([
      api.get('/api/users/create'),
    ])

    this.roles = rolesRes.data.map(role => ({ value: role.id, text: role.name }))

    if (this.userData.role_id === 5) {
      this.form.role_id = 7 // Forzar selección de "Paciente"
      this.roles = this.roles.filter(role => role.value === 7)
    }

    console.log('prueba', this.userData, this.clinics, this.roles)
  },
  setup() {
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loading = true
          try {
            const response = await api.post('/api/users', this.form)
            this.$bvToast.toast('Usuario registrado con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            if (this.$route.path === '/admin/pedidos/crear') {
              // Si está en esta ruta, cierra el modal
              this.$emit('close-modal')
            } else {
              // Si está en otra página, redirige
              this.$router.push({ name: 'admin-users' })
            }
          } catch (error) {
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    },
  },
}
</script>
